import React from 'react'

interface ValidationProps {
  errors: string[]
}

const ValidationSummary: React.FC<ValidationProps> = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null
  }

  return (
    <div className={'validation-summary'}>
      <ul>
        {errors.map((e) => (
          <li>{e}</li>
        ))}
      </ul>
    </div>
  )
}

export default ValidationSummary
